<template lang="pug">
v-dialog(v-model="dialog" width="550px" scrollable)
  v-card.pa-4(dark style="height:80vh")
    p.title Создание вебинара
    v-form(v-model="valid")
      v-text-field(
        v-model="form.name"
        filled
        label="Название"
        :rules="[rules.required]"
      )
      select-schedule-type(
        v-model="form.type"
        filled
        label="Тип"
        :rules="[rules.required]"
      )
      select-project(
        v-model="form.project_id"
        filled
        label="Проект"
        :rules="[rules.required]"
      )
      .d-flex.flex-gap
        time-picker(
          v-model="form.start_at"
          filled
          label="Время начала"
          :rules="[ruleForTime]"
        )
        time-picker(
          v-model="form.end_at"
          filled
          label="Время окончания"
          :rules="[ruleForTime]"
        )
      v-text-field(
        filled
        v-model="form.url"
        label="Ссылка на вебинар"
        :rules="[rules.required, rules.url]"
      )
      select-project-role(
        v-model="form.roles_name"
        returnName
        filled
        multiple
        :disabled="!form.project_id"
        :project-id="form.project_id"
      )
      template
        p.mb-0 Кто проводит вебинар
        v-radio-group(v-model="userType" row).mt-0
          v-radio(
            v-for="(type, value) in USER_TYPES_NAMES"
            :value="value"
            :key="value"
            :label="type"
          )

        v-text-field(
          v-if="userType === USER_TYPES.GUEST"
          v-model="form.user_full_name"
          filled
          label="Имя гостя"
          :rules="[rules.required]"
        )
        select-my-user(
          v-model="form.user_id"
          v-if="userType === USER_TYPES.USER"
          :query="{ 'search[parent_id]': this.user.id }"
          filled
        )
      v-text-field(
        v-if="isAdmin"
        v-model="form.user_full_name"
        filled
        label="Имя гостя"
        :rules="[rules.required]"
      )
      select-region(
        v-if="!isMunicipality && !isRegion"
        v-model="form.region_id"
        filled
        label="Регион"
        :rules="[rules.required]"
      )
      select-mun(
        v-if="!isMunicipality"
        v-model="form.municipality_id"
        :region="userRegion"
        :rules="[rules.required]"
        filled
        label="Муниципалитет"
      )

      select-pfdo-organizations(
        v-model="form.dispatcher_user_ids"
        v-if="form.municipality_id"
        :municipality-id="form.municipality_id"
        :rules="[rules.required]"
        filled
      )

      v-btn.mr-4(@click="submit" :loading="loading" color="success" :disabled="!valid") Сохранить
      v-btn(@click="dialog= false" text) Отменить
</template>

<script>
import SelectProjectRole from '@/components/inputs/SelectProjectRole.vue';
import SelectMyUser from '@/components/inputs/SelectMyUser.vue';
import mixinDateTime from '@/mixins/mixinDateTime';
import { CRUDWebinarSchedule } from '@/services/API/_crud';
import rules from '@/lib/rules';
import TimePicker from '@/components/TimePicker.vue';
import SelectRegion from '@/components/inputs/SelectRegion.vue';
import SelectMun from '@/components/inputs/SelectMun.vue';
import SelectScheduleType from '@/components/inputs/SelectScheduleType.vue';
import { mapGetters } from 'vuex';
import { USER_TYPES, USER_TYPES_NAMES } from '../constants';
import SelectProject from '@/components/inputs/SelectProject.vue';
import SelectPfdoMun from '@/components/inputs/SelectPfdoMun.vue';
import SelectPfdoOrganizations from '@/components/inputs/SelectPfdoOrganizations.vue';

const DEFAULT_FORM = {
  name: '',
  user_full_name:'',
  type: null,

  start_at: '12:00',
  end_at: '13:00',

  url:'',

  dispatcher_user_ids: [],

  roles_name:[],
  project_id: null,

  region_id: null,

  user_id: null,

  municipality_id: null,
};

export default {
  components:{
    SelectMyUser,
    TimePicker,
    SelectRegion,
    SelectMun,
    SelectProject,
    SelectScheduleType,
    SelectPfdoMun,
    SelectPfdoOrganizations,
    SelectProjectRole,
  },
  mixins: [mixinDateTime],
  props:{
    value: { type: Boolean, required: true },
    data: { type:Object, rerequired: false, default: null },
    day: { type: Date, rerequired: true, default: null },
  },
  data() {
    return {
      // roles names
      ctivator: null,
      attach: null,
      colors: ['green', 'purple', 'indigo', 'cyan', 'teal', 'orange'],
      editing: null,
      editingIndex: -1,

      nonce: 1,
      menu: false,
      roles_name: [],
      x: 0,
      search: null,
      y: 0,

      userType: USER_TYPES.GUEST,
      dialog: false,
      valid: false,
      loading: false,
      rules,
      form: { ...DEFAULT_FORM },
      USER_TYPES,
      USER_TYPES_NAMES,
    };
  },
  computed: {
    ...mapGetters({
      // Обязательно(!!!!) поискать способ во vuex импортить все геттеры.
      'isMunicipality':'auth/isMunicipality',
      'isSupport': 'auth/isSupport',
      'isAdmin':'auth/isAdmin',
      'isRegion': 'auth/isRegion',
      'user': 'auth/getUser',
    }),
    ruleForTime() {
      if (this.form.start_at && this.form.end_at) {
        return this.form.start_at < this.form.end_at || ['Введите корректное время'];
      }
      return true;
    },

    userRegion() {
      if (this.isRegion) return this.user.region_id;
      return null;
    },
  },
  watch:{
    // 'form.roles_name': function (val, prev) {
    //   if (val.length === prev.length) return;

    //   this.form.roles_name = val.map((v) => {
    //     if (typeof v === 'string') {
    //       v = { text: v };

    //       this.roles_name.push(v);

    //       this.nonce += 1;
    //     }

    //     return v;
    //   }).filter((name) => {
    //     if (typeof name === 'string') return name.length  > 3;
    //     return name.text.length > 3;
    //   });
    // },
    'value':{
      immediate: true,
      handler(v) {
        if (v && this.data) {
          this.form  = this.data;
        }
        this.dialog  = v;
      },
    },
    dialog(v) {
      this.$emit('input', v);
    },
  },
  methods:{
    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.editingIndex = index;
      } else {
        this.editing = null;
        this.editingIndex = -1;
      }
    },
    prepareDate(time) {
      const date = new Date(this.day.getFullYear(), this.day.getMonth() - 1, this.day.getDate());
      const start_at = new Date(date);
      const startTime = time.split(':');
      start_at.setHours(...startTime);
      return this.parseDateTime(start_at);
    },
    async submit() {
      this.loading = true;
      try {
        const params = { ...this.form };

        params.start_at = this.prepareDate(params.start_at);
        params.end_at = this.prepareDate(params.end_at);

        if (params.user_id && this.userType !== USER_TYPES.GUEST) delete params.user_full_name;
        else delete params.user_id;

        if (this.userType === USER_TYPES.ME) {
          params.user_id = this.user.id;
          delete params.user_full_name;
        }

        if (this.isRegion) delete params.region_id;

        // params.roles_name = params.roles_name.map(({ text }) => text);
        const response = await CRUDWebinarSchedule.create(params);

        this.$emit('addNewSchedules', response.data.data);
        this.$toast.success('Запись успешно добавлена');
        this.form = { ...DEFAULT_FORM };
        this.dialog = false;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>

</style>
